import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCategory = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-323.56 -348.44 2311.11 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M768 512V128Q768 76 730.0 38.0Q692 0 640 0H128Q76 0 38.0 38.0Q0 76 0 128V512Q0 564 38.0 602.0Q76 640 128 640H640Q692 640 730.0 602.0Q768 564 768 512ZM768 1280V896Q768 844 730.0 806.0Q692 768 640 768H128Q76 768 38.0 806.0Q0 844 0 896V1280Q0 1332 38.0 1370.0Q76 1408 128 1408H640Q692 1408 730.0 1370.0Q768 1332 768 1280ZM1664 512V128Q1664 76 1626.0 38.0Q1588 0 1536 0H1024Q972 0 934.0 38.0Q896 76 896 128V512Q896 564 934.0 602.0Q972 640 1024 640H1536Q1588 640 1626.0 602.0Q1664 564 1664 512ZM1664 1280V896Q1664 844 1626.0 806.0Q1588 768 1536 768H1024Q972 768 934.0 806.0Q896 844 896 896V1280Q896 1332 934.0 1370.0Q972 1408 1024 1408H1536Q1588 1408 1626.0 1370.0Q1664 1332 1664 1280Z"
	})
});
export default SvgCategory;
